module.exports = __webpack_public_path__ + "b176cd937a96c27dbbcab4b0a589f5f1.png";